import Dialog from '@mui/material/Dialog';
import { useSelector } from 'react-redux';
import FMFilterFormComponent from './FMFilterForm';

const FMFilterDrawer = ({ conversation }) => {
  const openDrawer = useSelector((state) => state.filters?.openDrawer);

  return (
    <Dialog
      open={Boolean(openDrawer)}
      fullWidth
      maxWidth="xs"
      PaperProps={{ sx: { borderRadius: 2 } }}
    >
      <FMFilterFormComponent conversation={conversation} />
    </Dialog>
  );
};

export default FMFilterDrawer;
